export default __webpack_public_path__ + "maps-examples-show-hide-layer-thumbnail-960-9fe7eb664f343534de3f28bff6d80f96.png";